export const riFilters = {
  data() {
    return {
      filtersRiLabel: {
        polNo: 'Policy No.',
        riType: 'Reinsurance Type'
      },
      filtersRi: {
        polNo: undefined,
        riType: undefined
      },
      paginationRi: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      riItems: [],
      totalItemsRi: 0,
      riHeaders: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Renewal Count', align: 'left', value: 'renCnt' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      riTypeList: [
        { value: 'C', label: 'C - Coinsurance' },
        { value: 'F', label: 'F - Facultative' }
      ]
    }
  },
  watch: {
    'paginationRi': function (value) {
      this.fetchRiOutwardsHelpListData()
    }
  }
}
